var _circle, _circle2, _circle3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalespersonManagerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9502,
    cy: 11.9499,
    r: 11.25,
    fill: "#162395"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9723_31733",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9521,
    cy: 11.9499,
    r: 11.25,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9521,
    cy: 11.9499,
    r: 11.25,
    stroke: "#FFD233"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9723_31733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3885 5.60913L24.2239 15.5807L14.1723 25.8591L7.86035 19.4707L12.3457 14.0247L14.3885 5.60913Z",
    fill: "#000A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3999 16.1296H9.77319V17.6755H13.3999V16.1296Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5476 16.5902L13.0719 16.3821V14.9106H10.0992V16.3821L9.63843 16.5902L9.75734 20.752H10.0992V21.406H13.0719V20.752H13.4138L13.5476 16.5902Z",
    fill: "#F6CCB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0994 14.9106V15.8173L13.0721 16.2781V14.9106H10.0994Z",
    fill: "#E3B9A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.435 23.6345C15.5094 21.3901 15.4202 17.258 13.6663 16.604L13.6068 16.827C13.4582 17.3175 12.9528 18.462 11.6448 18.462C10.4855 18.462 9.99498 17.5701 9.80176 17.0202L9.69771 16.604C7.95867 17.258 7.79517 21.3901 7.83976 23.6345H15.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8728 18.255L11.1552 18.8049H12.0322L12.2997 18.255L11.5863 17.6753L10.8728 18.255Z",
    fill: "#96281B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5847 17.6748L12.5063 18.6409L14.0669 16.783L13.0859 16.2925L12.7143 16.6343L11.5847 17.6748Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.085 16.2925L11.5863 17.6748L10.6796 18.6409L9.1189 16.7681L10.085 16.2925Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1947 23.6351L12.0312 18.314H11.1542L10.9907 23.6351H12.1947Z",
    fill: "#96281B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2997 23.6348C19.0767 21.9552 18.7943 20.3648 18.5565 18.9082C18.5119 18.6109 18.3782 18.3879 18.1998 18.1947C17.4863 17.3921 15.673 17.2583 13.6813 16.5151C13.6813 16.5151 11.6004 22.7132 11.6004 22.7281L9.51945 16.5151C7.09669 17.4218 4.94148 17.4218 4.70366 18.819C4.67393 18.9825 4.65906 19.146 4.65906 19.3095C4.42125 20.6621 4.18343 22.1187 3.97534 23.6497L11.6004 26.3251L19.2997 23.6348Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6642 16.7836L14.6047 18.1957L13.9061 18.7754L14.4561 19.5334L11.5874 22.6993L13.4156 16.1296L14.6642 16.7836Z",
    fill: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52686 16.7827L8.57145 18.1947L9.2849 18.7744L8.73495 19.5324L11.5888 22.6984L9.7754 16.1287L8.52686 16.7827Z",
    fill: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.826 10.7343L14.9301 9.42634C14.9301 7.71703 13.2951 6.33472 11.5858 6.33472C9.87646 6.33472 8.24146 7.71703 8.24146 9.42634L8.34551 10.7343C8.25633 10.7641 8.16714 10.8087 8.09283 10.8681C7.95905 10.987 7.86987 11.1505 7.86987 11.3437V11.9829C7.86987 12.3247 8.13741 12.5923 8.47928 12.6071C8.47928 14.2273 10.4264 15.7582 11.5858 15.7582C12.7451 15.7582 14.6922 14.2273 14.6922 12.6071C15.0341 12.6071 15.3017 12.3247 15.3017 11.9829V11.3437C15.3017 11.0465 15.1084 10.8087 14.826 10.7343Z",
    fill: "#F6CCB8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.826 10.7343L14.93 9.42634C14.93 7.71703 13.295 6.33472 11.5857 6.33472V10.7343C11.1398 11.7005 10.8425 13.0828 10.8425 13.0828H11.5857V15.7434C12.7451 15.7434 14.6922 14.2124 14.6922 12.5923C15.0341 12.5923 15.3016 12.3099 15.3016 11.968V11.3289C15.3016 11.0465 15.1084 10.8086 14.826 10.7343Z",
    fill: "#E8BEAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8847 7.34523C14.9144 6.92905 14.7807 6.34937 14.4537 5.50215C14.3793 5.30892 14.1118 5.26433 13.978 5.4427C13.6064 5.91833 13.1011 5.81428 12.2836 5.48729C10.9161 4.92247 9.90541 5.26433 9.32573 5.87374C6.41247 7.10741 8.3596 11.5962 8.3596 11.5962C8.3596 11.5962 8.34474 9.09913 9.38519 8.20732C9.42978 8.22218 11.5107 8.26678 11.5701 8.26678C11.7188 8.26678 13.6064 8.2965 14.0821 8.17759C15.0036 8.72754 14.7955 11.5814 14.7955 11.5814C14.7955 11.5814 15.7914 9.114 14.8847 7.34523Z",
    fill: "#3C2417"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalespersonManagerIcon);
export default __webpack_public_path__ + "static/media/SalespersonManagerIcon.92df80fc5a5924b6917f831905bcee97.svg";
export { ForwardRef as ReactComponent };